<template>
  <el-dialog title="轮询设置" :visible.sync="visible" @close="close()" width="350px"
    :show-close="true" :destroy-on-close="true">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row :gutter="15">
        <el-col :sm="24">
          <el-form-item label="是否参与轮询" prop="is_lx">
            <el-radio-group v-model="form['is_lx']">
              <el-radio v-for="item in radioList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="close()">取消</el-button>
      <el-button type="primary" @click="save()" :loading="loading">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';

/**
 * 轮询设置
 * */

export default {
  name: 'roundEdit',
  data() {
    return {
      visible: false, //弹窗是否显示
      loading: false, // 提交状态
      radioList: [],
      form: {
        'id': '',
        'is_lx': ''
      },
      formConfig: { 'is_lx': '' },
      rules: {
        "is_lx": [{
          required: true,
          message: '是否参与轮询',
          trigger: 'blur'
        }],
      }
    };
  },
  mounted() {
    loadDictOptions('yes_no_12', { numberValue: true })
      .then((list) => { this.radioList = list; })
      .catch((e) => { this.$message.error(e.message); });
  },
  methods: {
    show(data = {}) {
      this.visible = true;
      this.formConfig['is_lx'] = this.form['is_lx'] = data['is_lx'];
      this.form['id'] = data['id'];
    },
    close(type = false) {
      this.visible = false;
      if (type) {
        this.$emit('done')
      }
    },
    save() {
      this.$refs['form'].validate((valid) => {
        if (!valid || this.loading) {
          return
        }
        if (this.formConfig['is_lx'] == this.form['is_lx']) {
          this.$message.error('数据未发生变化');
          return
        }
        this.loading = true;
        this.$http.post('/channelcolumn/edit', this.form).then(res => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.close(true)
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          this.loading = false;
          this.$message.error(e.message);
        });
      })
    },
  }
}
</script>

<style></style>
